import React from 'react';
import { ArrowUpRight, Globe, MapPin, Phone } from 'lucide-react';
export function Footer() {
  const links = [{
    label: 'Studio',
    href: '#studio'
  }, {
    label: 'Capabilities',
    href: '#services'
  }, {
    label: 'Client stories',
    href: '#testimonials'
  }, {
    label: 'Contact',
    href: '#contact'
  }];
  return <footer className="border-t border-white/5 bg-dark-darker pb-10 pt-16" data-id="element-79" data-mp="3ufa6idot1hph">
      <div className="mx-auto max-w-[1320px] px-4" data-id="element-80" data-mp="3ud7i1y3avwmv">
        <div className="grid gap-12 md:grid-cols-[1.3fr_0.8fr_1fr]" data-id="element-81" data-mp="37o38m5zzh95">
          <div data-id="element-82" data-mp="3lelybzm3ebki">
            <a href="#home" className="mb-6 inline-block" aria-label="Byteweb home" data-id="element-83" data-mp="3lf57aqtrlpme">
              <img src="https://cdn.magicpatterns.com/uploads/5NTyxseHUpDeTNPmLZNFKL/ByteWeb8.png" alt="Byteweb" className="h-11 w-auto" data-id="element-84" data-mp="3qblzbw434o4r" />
            </a>
            <p className="max-w-sm font-inter leading-relaxed text-white/60" data-id="element-85" data-mp="2evxat0b6nh1u">
              Byteweb is a Cape Town digital studio helping organisations turn
              ambitious ideas into useful, high-performing digital experiences.
            </p>
          </div>

          <div data-id="element-86" data-mp="3v9b09eif82dd">
            <h2 className="mb-5 font-syne text-lg font-bold text-white" data-id="element-87" data-mp="3v5n7ihksvjzp">
              Explore
            </h2>
            <ul className="space-y-3" data-id="element-88" data-mp="3qazq12o7rpum">
              {links.map(link => <li key={link.label} data-id="element-89" data-mp="817e07obdsul">
                  <a href={link.href} className="font-inter text-sm text-white/60 transition-colors hover:text-gold" data-id="element-90" data-mp="34723g4s9vvk">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-91" data-mp="qt8f7gok9v76">
            <h2 className="mb-5 font-syne text-lg font-bold text-white" data-id="element-92" data-mp="qsqfga2owyui">
              Studio details
            </h2>
            <div className="space-y-4 font-inter text-sm text-white/60" data-id="element-93" data-mp="mt7q923u61lv">
              <a href="tel:+27712158291" className="flex items-center gap-3 transition-colors hover:text-gold" data-id="element-94" data-mp="tvw5sbdtv5dc">
                <Phone size={16} className="text-gold" data-id="element-95" data-mp="yrv00flu7hlo" />
                071 215 8291
              </a>
              <p className="flex items-center gap-3" data-id="element-96" data-mp="13rfzcr4x5ryx">
                <MapPin size={16} className="text-gold" data-id="element-97" data-mp="18ksor3hfa2sq" />
                Cape Town, South Africa
              </p>
              <a href="https://byteweb.co.za/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 transition-colors hover:text-gold" data-id="element-98" data-mp="1cl2vwjgyaz96">
                <Globe size={16} className="text-gold" data-id="element-99" data-mp="1rilef431cg86" />
                byteweb.co.za
                <ArrowUpRight size={14} data-id="element-100" data-mp="3ob551yhw6t30" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 border-t border-white/5 pt-8 text-center" data-id="element-101" data-mp="3t9yijqx6ik36">
          <p className="font-inter text-sm text-white/40" data-id="element-102" data-mp="3tccctxk1bs9o">
            © {new Date().getFullYear()} Byteweb. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}